import { Component } from '@angular/core';

@Component({
    selector: 'app-agents-analytics',
    templateUrl: './analytics.component.html',
    styleUrl: './analytics.component.scss',
    standalone: false
})
export class AnalyticsComponent {

}
